import appStore from 'store';
import api from './api';
import {
  STATUS_TYPE,
  DEPOSIT_STATUS_TYPE,
  ALL_DEPOSIT_ENSURED
} from './constants';

const store = {
  namespaced: true,
  state: {
    auditList: [],
    activeTab: '1',
    allCoins: [],
    chooseCoinType: '',
    userRecords: [],
    audistCount: 0,
    userDetailTotal: 0,
    userWallet: [],
    pagination: { page: 1, size: 25 },
    bidInfo:[],
    askInfo:[],
    totalBuy:0,
    totalSell:0,
    showTag:false,
    invite:'',
  },
  mutations: {
    setAuditList(state, payload) {
      state.auditList = payload.slice().map(item => {
        return {
          ...item,
          __status: STATUS_TYPE[item.txStatus],
          __allDepositEnsured: ALL_DEPOSIT_ENSURED[item.allDepositEnsured]
        };
      });
    },
    setInvite(state, payload){
      state.invite = payload;
    },
    changeTab(state, payload) {
      state.activeTab = payload;
    },
    setChooseTab(state, payload) {
      state.activeTab = payload;
    },
    setBillTypeList(state, payload) {
      state.billTypeList = payload;
    },
    setAllcoins(state, payload) {
      state.allCoins = payload;
    },
    setAudistCount(state, payload) {
      state.audistCount = payload;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setUserRecords(state, payload) {
      state.userRecords = payload.slice().map(item => {
        return {
          ...item,
          __status:
            item.txType === 1
              ? DEPOSIT_STATUS_TYPE[item.txStatus]
              : STATUS_TYPE[item.txStatus]
        };
      });
    },
    setUserDetailTotal(state, payload) {
      state.userDetailTotal = payload;
    },
    setChooseCoinType(state, payload) {
      state.chooseCoinType = payload;
    },
    setUserWallet(state, payload) {
      state.userWallet = payload;
    },
    setBidInfo(state,payload) {
      state.bidInfo = payload;
    },
    setAskInfo(state,payload) {
      state.askInfo = payload;
    },
    setTotalBuy(state,payload) {
      state.totalBuy = payload;
    },
    setTotalSell(state,payload) {
      state.totalSell = payload;
    },
    setShowTag(state,payload){
      state.showTag = payload;
    }
  },
  actions: {
    list({ commit }, query) {
      api.getAuditList(query).then(({ data }) => {
        let ary = [];
        let riskobj = {}
        data.list.map(item=>{
            ary.push(item.userId)
        })
        commit('setAuditList', data.list || []);
        commit('setAudistCount', data.totalCount || 0);
        commit('setPagination', { page: query.page, size: query.size });
        // api.userRiskFlagList([...ary]).then((obj)=>{
        //     riskobj = obj.data
        //     data.list.map(item=>{
        //         Object.keys(riskobj).forEach((key)=>{
        //         if(item.userId == key){
        //             item.riskFlag = riskobj[key]
        //         }
        //         })
        //     })
        //     commit('setAuditList', data.list || []);
        //     commit('setAudistCount', data.totalCount || 0);
        //     commit('setPagination', { page: query.page, size: query.size });
        // }).catch(err=>{
        //     commit('setAuditList', data.list || []);
        //     commit('setAudistCount', data.totalCount || 0);
        //     commit('setPagination', { page: query.page, size: query.size });
        // })
      });
    },
    // eslint-disable-next-line
    approve({ commit }, id) {
      return new Promise(resolve => {
        api.approveAudit(id).then(res => {
          resolve(res);
        });
      });
    },
    approveHand({ commit }, id) {
      return new Promise(resolve => {
        api.approveHand(id).then(res => {
          resolve(res);
        });
      });
    },
    // eslint-disable-next-line
    retry({ commit }, id) {
      return new Promise(resolve => {
        api.retryWithdrawal(id).then(res => {
          resolve(res);
        });
      });
    },
    setAuditToErr(context, id) {
      return new Promise(resolve => {
        api.setToErrList(id).then(res => {
          resolve(res);
        });
      });
    },
    cancelTheAudit(context, id) {
      return new Promise(resolve => {
        api.cancelAudit(id).then(res => {
          resolve(res);
        });
      });
    },
    listBillType({ commit }) {
      api.getBillTypeList().then(({ data }) => {
        commit('setBillTypeList', data);
      });
    },
    getAllCoins({ commit }) {
      api.getAllCoins().then(({ data }) => {
        commit('setAllcoins', data);
      });
    },
    getUserRecords({ commit }, data) {
      api.getUserRecords(data).then(({ data }) => {
        commit('setUserRecords', data.list || []);
        commit('setUserDetailTotal', data.totalCount || 0);
      });
    },
    getUserWallet({ commit }, data) {
      api.getUserWallet(data.userId).then(({ data }) => {
        commit('setUserWallet', data);
      });
    },
    getRebateAmount({ commit }, data) {
      api.getRebateAmount(data).then(({ data }) => {
        commit('setInvite', data);
      });
    },
    resetUserRecords({ commit }) {
      commit('setUserRecords', []);
      commit('setUserDetailTotal', 0);
      commit('setUserWallet', []);
    },
    changeCoinType({ commit }, data) {
      commit('setChooseCoinType', data);
    },
    changeChooseTab({ commit }, data) {
      commit('setChooseTab', data);
    },
    updateFreeze(context, data) {
      return api.updateFreeze(data);
    },
    cancelTwoWithdraw(context, data) {
      return api.cancelTwoWithdraw(data);
    },
    cancel(context, data) {
      return api.cancel(data);
    },
    sendWithdrawalTrans(context, data) {
      return api.sendTheWithdrawalTrans(data);
    },
    remark(context, data) {
      return api.remark(data);
    },
    manualConfirm(context, txId) {
      return api.manualConfirm(txId);
    },
    returnToNotApproved(context, txId) {
      return api.returnToNotApproved(txId);
    },

    getTradeBuyInfo({commit},data) {
      api.queryBuyMessage(data).then(response => {
        commit('setBidInfo',response.data.query);
        commit('setTotalBuy',response.data.total);
      })
    },

    getTradeSellInfo({commit},data) {
      api.querySellMessage(data).then(response => {
        commit('setAskInfo',response.data.query);
        commit('setTotalSell',response.data.total);
      })
    },

    saveShowTag({commit},data) {
      commit('setShowTag',data);
    }
  }
};

appStore.registerModule('withdrawalAudit', store);
